<h3 class="headline">Uploading {{ parsedProgress }}%</h3>
<sb-progress-bar [completion]="parsedProgress" />
<p class="mb-0 mt-2 t-10@r ash-color">{{ mediaType }}{{ count > 1 ? 's' : '' }} uploading. Please wait...</p>
